// import * as XLSX from "xlsx";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export const exportEmployeeToExcel = (data, companyName, companyDetails, fileName) => {
    const wb = XLSX.utils.book_new();
    const fp = fileName + ".xlsx";

    const keys = Object.keys(data[0] || {}); // Extract field names from first record
    const headers = keys.map(key => key.charAt(0).toUpperCase() + key.slice(1)); // Make headers readable

    // Prepare sheet data
    const wsData = [
        [companyName.toUpperCase()], // Row 1
        [companyDetails],
        [], // empty row
        headers.map(h => h.toUpperCase()),
        ...data.map(item => keys.map(key => item[key])) // dynamic rows
    ];

    //console.log("keys>>>>>>>>>>>>>",keys)
    const ws = XLSX.utils.aoa_to_sheet(wsData);


    // Merge header cells
    ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: keys.length - 1 } }, // Company name
        { s: { r: 1, c: 0 }, e: { r: 1, c: keys.length - 1 } }, // Address
        { s: { r: 2, c: 0 }, e: { r: 2, c: keys.length - 1 } }, // Contact/Email 
    ];

    const colWidths = wsData[3].map((header, colIndex) => {

        if (header && header.toString().toLowerCase().replace(/\s|\./g, '') === "sno") {
            return { wch: 6 };
        }
        let maxLength = header ? header.toString().length : 10;
        for (let i = 3; i < wsData.length; i++) {
            const value = wsData[i][colIndex];
            if (value) {
                maxLength = Math.max(maxLength, value.toString().length);
            }
        }

        return { wch: maxLength + 2 };
    });

    ws["!cols"] = colWidths;

    // Border styles
    const borderStyle = {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
    };

    const dottedBorderStyle = {
        top: { style: "dotted", color: { rgb: "000000" } },
        bottom: { style: "dotted", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
    };

    // Cell styles
    const companyHeaderStyle = {
        font: { bold: true, sz: 14, color: { rgb: "000000ff" } },
        fill: { fgColor: { rgb: "f5f6f7ff" } },
        alignment: { horizontal: "center", vertical: "center" },
        border: borderStyle,
    };

    const subHeaderStyle = { font: { sz: 11 }, alignment: { horizontal: "center" } };
    const tableHeaderStyle = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "4472C4" } },
        alignment: { horizontal: "center" },
        border: borderStyle,
    };
    const tableCellStyle = { border: dottedBorderStyle, alignment: { horizontal: "left" } };

    // Helper to apply style to a cell
    const setCellStyle = (cellAddress, style) => { if (!ws[cellAddress]) return; ws[cellAddress].s = style; };

    // Apply styles
    setCellStyle("A1", companyHeaderStyle);

    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
            if (!ws[cellRef]) continue;

            if (R === 0) ws[cellRef].s = companyHeaderStyle;
            else if (R === 1 || R === 2) ws[cellRef].s = subHeaderStyle;
            else if (R === 3) ws[cellRef].s = tableHeaderStyle;
            else if (R > 3) ws[cellRef].s = tableCellStyle;
        }
    }

    ws['!freeze'] = undefined; // remove old one if set
    ws['!pane'] = undefined;   // safety
    ws["!freeze"] = {
        xSplit: 0,
        ySplit: 5,
        topLeftCell: "A6",
        activePane: "bottomLeft",
        state: "frozen",
    };
    ws['!views'] = [
        {
            state: 'frozen',
            ySplit: 5,           // number of rows to freeze
            xSplit: 0,           // number of columns to freeze
            topLeftCell: 'A5',   // cell visible after frozen area
            activePane: 'bottomLeft'
        }
    ];

    // Add sheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, fileName);

    // Export
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(blob, fp);

}